import { render, staticRenderFns } from "./ProposalCommonFilters.vue?vue&type=template&id=e8f80716&"
import script from "./ProposalCommonFilters.vue?vue&type=script&lang=js&"
export * from "./ProposalCommonFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports